export const config = {
 bucketName: "serenetax",
 dirName: "documents",
 region: "ap-south-1",
 accessKeyId: 'AKIAXYKJWDQ7KOWQOYFU',
 secretAccessKey: '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',
};
